import { Box, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useHistory } from "react-router";

import { layoutTokens as layout } from "@/designTokens";

import { DetailLink } from "./DetailSection";
import { SimulationCharts } from "./SimulationCharts";

const useStyles = makeStyles({ settings: { padding: layout.space[24] } });

export const ManagementDetailSimulation: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Box>
      <Box className={classes.settings}>
        <DetailLink
          title="シミュレーション設定"
          description="予測に使う条件を変更"
          onClick={() => history.push("/management/detail/simulation")}
        />
      </Box>
      <SimulationCharts />
    </Box>
  );
};
